"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClientTypes;
(function (ClientTypes) {
    ClientTypes["ADMIN"] = "ADMIN";
    ClientTypes["WEBAPP"] = "WEBAPP";
    ClientTypes["GUEST"] = "GUEST";
    ClientTypes["ACTIVATE"] = "ACTIVATE";
    ClientTypes["GO"] = "GO";
    ClientTypes["DESKTOP_OSX"] = "DESKTOP.OSX";
    ClientTypes["DESKTOP_WINDOWS"] = "DESKTOP.WINDOWS";
    ClientTypes["DASH_DISPLAY"] = "DASH_DISPLAY";
    ClientTypes["DASH_PRESENTER"] = "DASH_PRESENTER";
    ClientTypes["DASH_TABLET_IOS"] = "DASH_TABLET.IOS";
    ClientTypes["DASH_TABLET_ANDROID"] = "DASH_TABLET.ANDROID";
    ClientTypes["MOBILE_IOS"] = "MOBILE.IOS";
    ClientTypes["MOBILE_ANDROID"] = "MOBILE.ANDROID";
    ClientTypes["CHROME_EXTENSION"] = "CHROME_EXTENSION";
    ClientTypes["OUTLOOK"] = "OUTLOOK";
    ClientTypes["LS_220"] = "LS_220";
    ClientTypes["ICON_300"] = "ICON_300";
    ClientTypes["ICON_500"] = "ICON_500";
    ClientTypes["ICON_600"] = "ICON_600";
    ClientTypes["ICON_700"] = "ICON_700";
    ClientTypes["ICON_900"] = "ICON_900";
    ClientTypes["GICON"] = "GICON";
    ClientTypes["SHARE"] = "SHARE";
})(ClientTypes = exports.ClientTypes || (exports.ClientTypes = {}));
